import {theme} from "Theme";
import {DialogLayout} from "base/dialog/components";

const EntityManageDialog = ({
    dialogTitle = null,
    isDialogOpen,
    dialogContent,
    onCloseDialog = null,
    size = "md",
    style = {},
}) => {
    return (
        <DialogLayout
            dialogTitle={dialogTitle}
            dialogContent={dialogContent}
            isDialogOpen={isDialogOpen}
            onHandleDialog={onCloseDialog}
            style={{
                backgroundColor: theme.palette.pageBackground.secondary,
                ...style,
            }}
            maxWidth={size}
            fullWidth
        />
    );
};

export default EntityManageDialog;
